



















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Emit, Model, Prop} from "vue-property-decorator";
import {EnumOption} from "@/interfaces/common";
import {enumToOptions} from "../../services/helper/utils";
import {LadingCustomerStatus} from "@/enums/status/ladingcustomerstatus";
import {mapperLadingCustomerStatus} from "@/enums/status";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";

@Component({
    name: "LadingCustomerStatusSelector",
    components: {EnumLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({ default: false })
    readonly disabled!: boolean;

    @Prop({ default: 'default' })
    readonly size!: string;

    @Prop({ type: String, required: true })
    readonly placeholder!: string;

    @Prop({ type: Boolean, default: false })
    readonly allowClear!: boolean;

    @Model("change", { required: true })
    readonly valueSelected!: number|string;

    @Emit("change")
    handleChange(value: number|string) {
        this.$emit('status-string', mapperLadingCustomerStatus[value]?.join(','));
        return value;
    }

    get options(): EnumOption[] {
        return enumToOptions(LadingCustomerStatus);
    }
}
